/* APEXFLOW package picker on the product page. Markup: snippets/apex-bundle.liquid.
   Packages are variants (1 / 3 / 5 bottles); the subscription checkbox attaches the
   variant's Loop selling plan. Adding goes through window.apexCart (assets/apex-cart.js),
   which adds the free gifts with the bottles and opens the cart drawer. */
(function () {
  if (window.__apexBundle) return;
  window.__apexBundle = true;

  function paint(box) {
    var sub = box.getAttribute('data-sub') === '1';
    box.querySelectorAll('[data-q]').forEach(function (b) {
      var p = b.querySelector('[data-apb-price]'), w = b.querySelector('[data-apb-was]');
      if (p) p.textContent = sub ? b.getAttribute('data-sub-price') : b.getAttribute('data-one');
      if (w) w.textContent = sub ? b.getAttribute('data-sub-was') : b.getAttribute('data-one-was');
    });
  }

  document.addEventListener('change', function (ev) {
    var ck = ev.target.closest('[data-apb-subscribe]');
    if (!ck) return;
    var box = ck.closest('[data-apex-bundle]');
    box.setAttribute('data-sub', ck.checked ? '1' : '0');
    paint(box);
  });

  document.addEventListener('click', function (ev) {
    var tile = ev.target.closest('[data-apex-bundle] [data-q]');
    if (tile) {
      var box = tile.closest('[data-apex-bundle]');
      box.setAttribute('data-t', tile.getAttribute('data-q'));
      box.querySelectorAll('[data-q]').forEach(function (b) { b.setAttribute('aria-checked', b === tile ? 'true' : 'false'); });
      return;
    }
    var add = ev.target.closest('[data-apex-bundle] [data-apb-add]');
    if (!add) return;
    ev.preventDefault();
    var root = add.closest('[data-apex-bundle]');
    var err = root.querySelector('[data-apb-error]');
    if (!window.apexCart) return;
    var q = Number(root.getAttribute('data-t'));
    var bar = root.querySelector('[data-q="' + q + '"]');
    var plan = root.getAttribute('data-sub') === '1' ? bar.getAttribute('data-plan') : '';
    var label = add.textContent;
    add.disabled = true;
    add.textContent = add.getAttribute('data-adding') || label;
    if (err) err.hidden = true;
    window.apexCart.addBundle(root.getAttribute('data-pid'), q, plan)
      .then(window.apexCart.refresh)
      .then(window.apexCart.openDrawer)
      .catch(function (e) {
        if (err) { err.textContent = (e && (e.description || e.message)) || add.getAttribute('data-error') || 'Something went wrong.'; err.hidden = false; }
      })
      .then(function () { add.disabled = false; add.textContent = label; });
  });
})();
